import { Button, Text } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { useNotificationContext } from "../context";
import { NotificationList } from "./NotificationList";

export const NotificationDropdown = () => {
  const { t } = useI18n();
  const { notifications, markAllAsRead } = useNotificationContext();

  const hasNotifications = notifications.length > 0;

  return (
    <div className="flex flex-col max-w-[27.5rem] max-h-[37.5rem] w-full">
      <div className="flex h-14 shrink-0 items-center justify-between ps-4 pe-1 gap-2 border-b border-neutral-500/10">
        <Text size="sm" weight="medium" className="text-neutral-500">
          {t("apps.admin.notifications.title")}
        </Text>
        {hasNotifications && (
          <div className="flex items-center ms-auto">
            <Button
              variant="ghost"
              color="primary"
              size="sm"
              onClick={markAllAsRead}
            >
              {t("apps.admin.notifications.readAll")}
            </Button>
          </div>
        )}
      </div>

      <NotificationList />
    </div>
  );
};
